import type { IGetPaymentInfoResponse } from '@/shared/api/models.bff';
import type { IPolicyStorePolicyPaymentInfo } from '../store/policyStore.model';

export interface IPayNowInfo {
  totalPaymentAmount: number;
  minimumPaymentAmount: number;
  inSufficientFunds: boolean;
  hasAnnuity: boolean;
  hasMultipleOptions: boolean;
  isPastDue: boolean;
  isPTDFuture: boolean;
  pastDueAmount: string;
  pastDueAmountPlusPac: string;
  pastDueDays: number;
}

export const mapPaymentInfoResponse = (
  paymentInfo: IGetPaymentInfoResponse
): IPolicyStorePolicyPaymentInfo => {
  const mappedPaymentInfo = {
    accountName: paymentInfo.AccountName,
    accountNumber: paymentInfo.AccountNumber,
    accountType: paymentInfo.AccountType,
    isSavingsAccount: paymentInfo.AccountType === '3',
    annualPremium: parseFloat(paymentInfo.AnnualPremium),
    autoDraftPaymentDate: paymentInfo.AutoDraftPaymentDate,
    billForm: paymentInfo.BillForm,
    billMode: paymentInfo.BillMode,
    billToDate: paymentInfo.BillToDate,
    errorMessage: paymentInfo.ErrorMessage,
    modePremiumAmount: paymentInfo.ModePremiumAmount,
    newPremiumAmount: paymentInfo.NewPremiumAmount,
    nextCycleDate: paymentInfo.NextCycleDate,
    minimumPaymentAmount: parseFloat(paymentInfo.MinimumPaymentAmount),
    monthlyPremium: parseFloat(paymentInfo.PACPremium),
    paidToDate: paymentInfo.PaidToDate,
    payInProcess: paymentInfo.PayInProcess === '1', // TODO: find references of PayInProcess
    policyNumber: paymentInfo.PolicyNumber,
    policyRecordID: paymentInfo.PolicyRecordID,
    policyStatus: paymentInfo.PolicyStatus,
    quarterlyPremium: parseFloat(paymentInfo.QuarterlyPremium),
    restrictCode: paymentInfo.RestrictCode,
    returnCode: paymentInfo.ReturnCode,
    routingNumber: paymentInfo.RoutingNumber,
    semiAnnualPremium: parseFloat(paymentInfo.SemiAnnualPremium),
    suspendCode: paymentInfo.SuspendCode,
    totalPaymentAmount: parseFloat(paymentInfo.TotalPaymentAmount),
    zipCode: paymentInfo.ZipCode,
    bank: {
      account: paymentInfo.AccountNumber,
      name: paymentInfo.BankName,
      payorName: paymentInfo.AccountName,
    },
    ...paymentInfo,
  };

  return mappedPaymentInfo;
};

export const mapPayNowInfoResponse = (paymentInfo: IGetPaymentInfoResponse): IPayNowInfo => {
  return {
    totalPaymentAmount: parseFloat(paymentInfo.TotalPaymentAmount),
    minimumPaymentAmount: parseFloat(paymentInfo.MinimumPaymentAmount),
    inSufficientFunds: paymentInfo.InSufficientFunds,
    hasAnnuity: paymentInfo.DisplayAnnuity,
    hasMultipleOptions: paymentInfo.HasMultipleOptions,
    isPastDue: paymentInfo.IsPastDue,
    isPTDFuture: paymentInfo.IsPTDFuture,
    pastDueAmount: paymentInfo.PastDueAmount,
    pastDueAmountPlusPac: paymentInfo.PastDueAmountPlusPac,
    pastDueDays: paymentInfo.PastDueDays,
  };
};
